import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";

import '../../../i18/config';
import {useTranslation} from "react-i18next";

import {useHistory, useRedux, useSearchInput} from "../../../hooks";

import {
    editDataContentTemplates,
    getContentTemplates,
    onRemoveContentTemplates,
    removeContentTemplatesModalHide,
    removeContentTemplatesModalShow,
    showRightModalContentTemplates
} from "../../../redux/actions";
import TableList from "../../../components/TableList";
import ContentTemplateColumns from "./tableColumns";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import {HistoryHashType, PAGINATION_DEFAULT_ITEMS_PER_PAGE} from "../../../data/settings";
import Loader from "../../../components/Loader";
import {ContentTemplateType} from "../../../redux/Content/Template/types";
import MainListFilter from "../../../components/MainListFilter";

const TemplatesIndex = () => {
    const { dispatch, useAppSelector } = useRedux();
    const { t } = useTranslation(['common']);

    const componentType = 'contentTemplateTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getContentTemplates,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const [perPage, setPerPage] = useState(PAGINATION_DEFAULT_ITEMS_PER_PAGE);

    const {
        contentTemplates,
        isContentTemplatesFetched
    } = useAppSelector(state => ({
        contentTemplates: state.ContentTemplates,
        isContentTemplatesFetched: state.ContentTemplates.isFetched
    }));

    useEffect(() => {
        if (contentTemplates.isNeedReload){
            loadItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, contentTemplates.isNeedReload]);

    const openRightModal = (event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataContentTemplates({data:event, modalEditTitle: 'changeTemplate'}));
        } else {
            dispatch(showRightModalContentTemplates({modalEditTitle: 'newTemplate'}));
        }
    };

    const onEntityRemoveModalShow = (event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(removeContentTemplatesModalShow({data:event, modalEditTitle: 'deleteTemplate'}));
        }
    };

    const onEntityRemoveModalHide = () => dispatch(removeContentTemplatesModalHide());

    const onEntityRemove = (event:any) => {
        if ((event !== undefined) && (event.uuid.length>0)){
            dispatch(onRemoveContentTemplates({data:event, modalEditTitle: 'deleteTemplate'}));
        }
    };

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = (item:ContentTemplateType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    }

    const columns = ContentTemplateColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:templates')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('template:myTemplates')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isContentTemplatesFetched?
                                    <TableList
                                        columns={columns}
                                        data={contentTemplates.items}
                                        onRowClick={onTableRowClick}
                                        key={componentType}
                                        historyHash = {historyHash}
                                        paginationTotalRows={contentTemplates?.meta?.totalCount || 0}
                                        paginationServer={true}
                                        isShowChangePageSize={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={contentTemplates.selectedItem}
                    isOpen={contentTemplates.removeModalShow}
                    modalTitle={contentTemplates.modalEditTitle}/>
        </>
    );
};

export default TemplatesIndex;


